import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { FontNormal } from '@css/fonts';
import {
  pageMaxWidth,
  cardMaxWidth,
  cardContentMaxWidth,
  black,
  dividerGray,
  tabletMax,
  tabletMin,
  mobileMax,
  gray,
  white,
  MQ,
} from './constants';
import { fontSize } from "@css/styles";

export const Clear = styled('div')(css`
  clear: both;
`);

export const Sep = styled('div')(css`
  height: 1px;
  margin: 10px 0;
  background-color: ${dividerGray};
`);

export const Separator = styled(Sep)<{ size: 'small' | 'big' }>(props => css`
  height: 2px;
  margin: 20px auto;
  max-width: ${props.size === 'small' ? '545px' : 'auto'};

`);

export const WidthWrapper = styled('div')(css`
  max-width: ${pageMaxWidth};
  margin: 0 auto;
`);

export const PageWrapper = styled('div')<{
  shadowed?: boolean
}>(props => css`
  width: 90%;
  max-width: ${pageMaxWidth};
  margin: 5px auto 0;
  background-color: ${white};
  text-align: center;
  border-radius: 2px;
  overflow-x: hidden;
  box-shadow: ${props.shadowed ? '0px 4px 12px rgba(26, 28, 31, 0.15)' : 'none'};

  ${MQ.SMALL_SCREENS} {
    box-shadow: none;
  }
`);

export const CardContainer = styled('div')(css`
  width: 90%;
  max-width: ${cardMaxWidth};
  margin: 0 auto;
`);

export const CardSectionTitle = styled('h3')(css`
  ${FontNormal(600)}
  ${fontSize(24)};

  margin-bottom: 8px;

  color: ${black};
  text-align: left;
`);

export const CardSubSectionTitleContainer = styled('div')(css`
  display: flex;
  width: 90%;
  max-width: ${cardMaxWidth};
`);

export const CardSubSectionTitleImage = styled('img')(css `
  margin-right: 8px;
  height: 12px;
`)

export const CardSubSectionText = styled('p')(css `
  ${FontNormal(600)};
`);

export const cardStyle = css`
  background-color: ${white};
  box-shadow: 0px 4px 12px rgba(26, 28, 31, 0.15);
  border-radius: 2px;
`;

export const Card = styled('div')(css`
  ${cardStyle};
`);

export const BorderedCard = styled('div')(css`
  ${cardStyle};
  border: 1px solid ${gray};
`);

export const DesktopCard = styled('div')(css`
  @media(min-width: ${tabletMin}) {
    ${cardStyle};
  }
`);

export interface ICardBorderedProps {
  color: string;
}
export const CardBordered = styled('div')<ICardBorderedProps>((props) => css`
  background-color: ${white};
  box-shadow: 0px 4px 12px rgba(26, 28, 31, 0.15);
  border-radius: 2px;
  border-left: 8px solid ${props.color};
`);

export const cardContentStyle = css`
  max-width: ${cardContentMaxWidth};
  width: 85%;
  padding: 50px 0;
  margin: 0 auto;

  @media(max-width: ${tabletMax}) {
    padding: 40px 0;
  }
`;

export const CardContent = styled('div')(css`
  ${cardContentStyle}

  @media(max-width: ${mobileMax}) {
    padding: 30px 0;
  }
`);

export const DesktopCardContent = styled('div')(css`
  @media(min-width: ${tabletMin}) {
    ${cardContentStyle}
  }
`);

export const CardHeader = styled('div')(css`
  display: flex;
`);

export const CardImage = styled('img')(css`
  height: 24px;
  margin-right: 8px;
`);

export const CardTitle = styled('p')(css`
  ${FontNormal(600)};
  ${fontSize(20)};

  color: ${black};
  text-align: left;
`);

export const CardText = styled('p')(css`
  ${FontNormal(400)}
  ${fontSize(16)};

  margin-top: 15px;
  color: ${black};
  text-align: left;
`);
